import React from "react";
import UpdateButton from "@components/FlowActionButtons/UpdateButton";
import { canUserUpdate } from "./utils";

interface UpdateMovementProps {
  movementFlowData?: {
    id: string;
    task: { status: string; claimOwnerName: string } | null;
    status: string;
    terminalReport: { report: string } | null;
    to: string;
    from: string;
  };
  openDrawer: (drawerName: string) => void;
}

const LANG_BASE = "vessel-call.movement-services";

const UpdateMovement: React.FC<UpdateMovementProps> = ({ movementFlowData, openDrawer }) => {
  if (!movementFlowData) {
    return null;
  }

  if (!movementFlowData.task) {
    return null;
  }

  const isActionAvailable = canUserUpdate(
    movementFlowData.task.status,
    movementFlowData.task.claimOwnerName,
    movementFlowData.status,
  );
  const handleUpdateClick = () => {
    openDrawer("updateDrawer");
  };
  return (
    <UpdateButton
      langBase={LANG_BASE}
      permission="canUpdateMovementService"
      isActionAvailable={isActionAvailable}
      onUpdate={handleUpdateClick}
    />
  );
};
export default UpdateMovement;
